export default "__VITE_ASSET__s5P_Xbjq__"